export const LayoutIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.996094"
        y="0.5"
        width="18.2939"
        height="18.2939"
        rx="3.5"
        stroke="black"
      />
      <line
        x1="6.79199"
        y1="19.2939"
        x2="6.79199"
        y2="-1.88549e-06"
        stroke="black"
      />
      <line x1="19" y1="6.5" x2="1" y2="6.5" stroke="black" />
    </svg>
  );
};
